import { useLocation as useLocation } from 'react-router';
import { KProperty02ce7r476m8633 as KProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  setDefaultKeyykye56baz645 as setDefaultKey,
  addChildNodeajp8y977cuss as addChildNode,
  addChildspxcpid5g99g as addChild,
} from '../../../../../../kotlin-react/react/ChildrenBuilder.mjs';
import { ReactHTML_instance1fv1xc01x8ngo as ReactHTML_instance } from '../../../../../../kotlin-react-dom/react/dom/html/ReactHTML.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { nfcrfe5635r1kf5 as nfc } from '../../../../../../jsmints-minreact/com/zegreatrob/minreact/ReactFunction.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_LostRoute() {
  _init_properties_LostRoute_kt__xja4tp();
  var tmp = KProperty0();
  return LostRoute$delegate.f1m(null, getPropertyCallableRef('LostRoute', 0, tmp, _get_LostRoute_$ref_d8362j(), null));
}
var LostRoute$delegate;
function LostRoute$delegate$lambda($this$nfc, it) {
  _init_properties_LostRoute_kt__xja4tp();
  var location = useLocation();
  setDefaultKey($this$nfc, '@rdk/9_4');
  // Inline function 'react.dom.html.ReactHTML.div' call
  // Inline function 'react.IntrinsicType' call
  // Inline function 'js.reflect.unsafeCast' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'react.ChildrenBuilder.invoke' call
  var block = ($this$div) => {
    // Inline function 'react.ChildrenBuilder.unaryPlus' call
    // Inline function 'react.ReactNode' call
    // Inline function 'js.reflect.unsafeCast' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = 'Hmm, you seem to be lost. At ' + location.pathname;
    addChildNode($this$div, tmp$ret$6);
    return Unit_instance;
  };
  addChild($this$nfc, 'div', block);
  return Unit_instance;
}
function _get_LostRoute_$ref_d8362j() {
  return constructCallableReference(() => get_LostRoute(), 0, 0, 283);
}
var properties_initialized_LostRoute_kt_fd3esr;
function _init_properties_LostRoute_kt__xja4tp() {
  if (!properties_initialized_LostRoute_kt_fd3esr) {
    properties_initialized_LostRoute_kt_fd3esr = true;
    LostRoute$delegate = nfc(LostRoute$delegate$lambda);
  }
}
//region block: exports
export {
  get_LostRoute as get_LostRoute3by3r5cvpo4mj,
};
//endregion

//# sourceMappingURL=LostRoute.mjs.map
